import { z } from 'zod';

// numeric(10, 2) rounds decimal ties away from zero before checking its eight integer digits.
const SCORE_ROUNDING_LIMIT = 99_999_999.995;

/** Accept scores that remain representable after storage in an evaluation result's numeric(10, 2) column. */
export const PersistedScoreSchema = z
  .number()
  .gt(-SCORE_ROUNDING_LIMIT)
  .lt(SCORE_ROUNDING_LIMIT)
  .describe(
    'Finite score stored to two decimal places. The absolute value must be less than 99999999.995 to avoid overflow after rounding.',
  );
